import { useEffect } from 'react';

const useGlobalCssVariable = (name, value) => {
  useEffect(() => {
    document.documentElement.style.setProperty(name, value);
  }, [value]);
};

export default useGlobalCssVariable;
